/**
 * Test IDs for QA automation.
 */
export const testIds = {
  excelImporterClose: "excel-importer-close",
  excelImporterFile: "excel-importer-file",
  excelImporterBack: "excel-importer-back",
  excelImporterNext: "excel-importer-next",
} as const;
